
const state = {
  msgNum: 0,
  socketFlag: 0,
  isOpenid: 0,
  breadListState: [],
  pageAllData: {
    id: 4
  },//自检当前在编辑的所有数据
  user: null,
  roles: [],//
  routers: [],
  isLogin:0,//1-登录 0-未登录
}

const mutations = {
  SET_NUM: (state, num) => {
    state.msgNum = num
  },
  SET_SOCKETFLAG: (state, num) => {
    state.socketFlag = num
  },
  SET_OPENID: (state, num) => {
    state.isOpenid = num
  },
  // SET_NUM:()=>{
  //   state.
  // }
  breadListMutations(state, list) {
    state.breadListState = list;
  },
  set_PageAllData(state, list) {
    state.pageAllData = list;
  },
  set_user(state, list) {
    state.user = list;
  },
  SET_ROLES(state, list) {
    state.roles = list;
  },
  SET_ROUTER(state, list){
    state.routers = list;
  },
  SET_isLogin(state, list){
    state.isLogin = list;
  },
}

const actions = {
  setRouter({ commit, state }, num) {
    commit('SET_ROUTER', num)
  },
  setNum({ commit, state }, num) {
    commit('SET_NUM', num)
  },
  setSocketFlag({ commit, state }, num) {
    commit('SET_SOCKETFLAG', num)
  },
  setOpenid({ commit, state }, num) {
    commit('SET_OPENID', num)
  },
  setBreadListMutations({ commit, state }, num) {
    commit('breadListMutations', num)
  },
  setPageAllData({ commit, state }, num) {
    commit('set_PageAllData', num)
  },
  setUser({ commit, state }, num) {
    commit('set_user', num)
  },
  setRoles({ commit, state }, num) {
    commit('SET_ROLES', num)
  },
  setIslogin({ commit, state }, num) {
    commit('SET_isLogin', num)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
